import { isMotionValue } from 'motion-dom';

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    return isMotionValue(value) ? value.get() : value;
}

export { resolveMotionValue };
//# sourceMappingURL=resolve-motion-value.mjs.map
